// useChatUserID.ts
"use client"
import { uid } from '@/utils/fncts';
import { useEffect, useState } from 'react';

const useChatUserID = (sessionID?: number ) => {
  const [chatUserID, setChatUserID] = useState<string |number>('');

  useEffect(() => {
    const storedUserID = localStorage.getItem('chatDrawerUserID');
    if (sessionID) {
      setChatUserID(sessionID);
    } else if (storedUserID) {
      setChatUserID(storedUserID);
    } else {
      const newUserID = uid(); // Generate a new chatUserID if not stored
      localStorage.setItem('chatDrawerUserID', newUserID);
      setChatUserID(newUserID);
    }
  }, [sessionID]);

  return chatUserID;
};

export default useChatUserID;
